import { FORBIDDEN_CERTIFICATE_CLAIM_PHRASES } from "../launch-certificate/launch-certificate-copy.js";
import { LAUNCH_PROOF_CLIENT_SAFE_FORBIDDEN_KEYS } from "../reports/sanitize-client-safe-launch-proof.js";
import { assertNoForbiddenClientSafePhrases } from "../reports/sanitize-client-safe-report.js";
const OWNERSHIP_FORBIDDEN_KEYS = [
    ...LAUNCH_PROOF_CLIENT_SAFE_FORBIDDEN_KEYS,
    "ownershipRecordId",
    "agencyId",
    "projectId",
    "runId",
    "updatedByUserId",
    "checklistJson",
    "clientSafeViewJson",
];
export function assertNoClientSafeOwnershipLeaks(serialized) {
    for (const key of OWNERSHIP_FORBIDDEN_KEYS) {
        if (serialized.includes(`"${key}"`)) {
            throw new Error(`client_safe_ownership_leak:${key}`);
        }
    }
    const lower = serialized.toLowerCase();
    for (const phrase of FORBIDDEN_CERTIFICATE_CLAIM_PHRASES) {
        if (lower.includes(phrase)) {
            throw new Error(`client_safe_ownership_forbidden_claim:${phrase}`);
        }
    }
    if (lower.includes("legal proof of ownership")) {
        throw new Error("client_safe_ownership_forbidden_claim:legal proof of ownership");
    }
    assertNoForbiddenClientSafePhrases(serialized);
}
//# sourceMappingURL=sanitize-client-safe-ownership.js.map